// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__335r2","productName":"Table_productName__5aD6P"};